import {
  ChartColumnIcon,
  CircleHelp,
  FileText,
  Globe,
  Lightbulb,
  PieChart,
  ScanSearch,
  SearchIcon,
  SparklesIcon,
  Users,
} from 'lucide-react';

import { ROUTE_PATTERNS } from '@/shared/config/routes';
import { i18n } from '@/shared/i18n';

import type { AnalysisSection } from './AnalysisSidebar.types';

// Labels are getters so each read resolves against the active locale; a plain
// `i18n.t(...)` here would freeze the English string at import time.
export const ANALYSIS_SECTIONS: AnalysisSection[] = [
  {
    id: ROUTE_PATTERNS.IQ_SECTION_EXECUTIVE_SNAPSHOT,
    get label() {
      return i18n.t('analysis:analysis.analysisSidebar.executiveSnapshot');
    },
    icon: <FileText className="size-4" />,
  },
  {
    id: ROUTE_PATTERNS.IQ_SECTION_BUSINESS_CHALLENGE,
    get label() {
      return i18n.t('analysis:analysis.analysisSidebar.businessChallenge');
    },
    icon: <CircleHelp className="size-4" />,
  },
  {
    id: ROUTE_PATTERNS.IQ_SECTION_BRAND_XRAY,
    get label() {
      return i18n.t('analysis:analysis.analysisSidebar.brandXRay');
    },
    icon: <ScanSearch className="size-4" />,
  },
  {
    id: ROUTE_PATTERNS.IQ_SECTION_AUDIENCE_PROFILES,
    get label() {
      return i18n.t('analysis:analysis.analysisSidebar.audienceProfiles');
    },
    icon: <Users className="size-4" />,
  },
  {
    id: ROUTE_PATTERNS.IQ_SECTION_CATEGORY_COMPETITION,
    get label() {
      return i18n.t('analysis:analysis.analysisSidebar.categoryCompetition');
    },
    icon: <PieChart className="size-4" />,
  },
  {
    id: ROUTE_PATTERNS.IQ_SECTION_CULTURE_CONTEXT,
    get label() {
      return i18n.t('analysis:analysis.analysisSidebar.cultureContext');
    },
    icon: <Globe className="size-4" />,
  },
  {
    id: ROUTE_PATTERNS.IQ_SECTION_BUSINESS_OPPORTUNITIES,
    get label() {
      return i18n.t('analysis:analysis.analysisSidebar.businessOpportunities');
    },
    icon: <Lightbulb className="size-4" />,
  },
  {
    id: ROUTE_PATTERNS.IQ_SECTION_MARKETING_PERFORMANCE,
    get label() {
      return i18n.t('analysis:analysis.analysisSidebar.marketingPerformance');
    },
    icon: <SearchIcon className="size-4" />,
  },
  {
    id: ROUTE_PATTERNS.IQ_SECTION_MEDIA_LANDSCAPE,
    get label() {
      return i18n.t('analysis:analysis.analysisSidebar.mediaLandscape');
    },
    icon: <ChartColumnIcon className="size-4" />,
  },
  {
    id: ROUTE_PATTERNS.IQ_SECTION_CREATIVE_LANDSCAPE,
    get label() {
      return i18n.t('analysis:analysis.analysisSidebar.creativeLandscape');
    },
    icon: <SparklesIcon className="size-4" />,
  },
];

export const SIDEBAR_WIDTH = 280;
